import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { FirestoreDatePipe } from './pipes/firestore-date.pipe';
import { SafeTimeagoPipe } from './pipes/safe-timeago.pipe';
import { TimeagoModule } from 'ngx-timeago';
import { RolePipe } from './pipes/role.pipe';
import { DisplayNamePipe } from './pipes/display-name.pipe';
import { TermsTextComponent } from './components/terms-text/terms-text.component';
import { TermsModalComponent } from './components/terms-modal/terms-modal.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { PendingGroupInvitesModalComponent } from './components/pending-group-invites-modal/pending-group-invites-modal.component';
import { DateInputMaskDirective } from './directives/date-input-mask.directive';
import { AuthErrorDisplayComponent } from './components/auth-error-display/auth-error-display.component';
import { AuthErrorModalComponent } from './components/auth-error-modal/auth-error-modal.component';
import { MfaEnrollmentComponent } from './components/mfa-enrollment/mfa-enrollment.component';
import { MfaAuthenticatorAppModalComponent } from './components/mfa-authenticator-app-modal/mfa-authenticator-app-modal.component';
import { MfaEnrollmentModalComponent } from './components/mfa-enrollment-modal/mfa-enrollment-modal.component';
import { MfaGraceBannerComponent } from './components/mfa-grace-banner/mfa-grace-banner.component';
import { MfaPromptModalComponent } from './components/mfa-prompt-modal/mfa-prompt-modal.component';
import { MfaReauthenticationModalComponent } from './components/mfa-reauthentication-modal/mfa-reauthentication-modal.component';

const DECLARE_AND_EXPORT = [
  AuthErrorDisplayComponent,
  FirestoreDatePipe,
  SafeTimeagoPipe,
  RolePipe,
  DisplayNamePipe,
  TermsTextComponent,
  DateInputMaskDirective,
  MfaEnrollmentComponent,
  MfaGraceBannerComponent,
];

@NgModule({
  declarations: [
    DECLARE_AND_EXPORT,
    TermsModalComponent,
    ConfirmModalComponent,
    AuthErrorModalComponent,
    PendingGroupInvitesModalComponent,
    MfaAuthenticatorAppModalComponent,
    MfaEnrollmentModalComponent,
    MfaPromptModalComponent,
    MfaReauthenticationModalComponent,
  ],
  imports: [
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    FontAwesomeModule,
    TimeagoModule,
    NgxSkeletonLoaderModule,
  ],
  exports: [
    CommonModule,
    NgOptimizedImage,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgbModalModule,
    FontAwesomeModule,
    TimeagoModule,
    NgxSkeletonLoaderModule,
    ...DECLARE_AND_EXPORT
  ]
})
export class SharedModule { }
